import QuetionsWrapper from "./QuestionsWrapper";

export default QuetionsWrapper